module.exports = __webpack_public_path__ + "static/media/mama.norwood - 1.56e2089c.jpg";